(function($) {
    var primaryNavigation = $('#primaryNavigation');
    var siteHeader = $('#siteHeader');
    var siteHeaderHeight = siteHeader.outerHeight();
    var siteMain = $('#siteMain');

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            siteHeader.removeClass('nav-open');
            $this
                .attr('aria-expanded', 'false')
                .removeClass('is-expanded');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            siteHeader.addClass('nav-open');
            $this
                .attr('aria-expanded', 'true')
                .addClass('is-expanded');
        }
    });

    $('.nav-item-back').each(function() {
        $(this)
            .closest('.dropdown-menu')
            .find('.dropdown-toggle')
            .hide()
    });

}(jQuery));
